var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"v-loader-button"},_vm._l((3),function(item){return _c('div',{staticClass:"v-loader-button__icon"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }